module.exports = __webpack_public_path__ + "img/wrif-color.c381581.svg";